export enum AribaIntegrationType {
  ONE_TIME = 'one_time',
  CONTINUOUS = 'cont',
}
